import avatarMityaFomin from '@images/avatar_mitya_fomin.jpg';
import avatarValeriaLanskaya from '@images/avatar_valeria_lanskaya.jpg';
import avatarAnatoliyRudenko from '@images/avatar_anatoliy_rudenko.jpg';
import avatarPavelOsipov from '@images/avatar_pavel_osipov.jpg';
import avatarTwixiTwins from '@images/avatar_twixi_twins.jpg';
import avatarDirector from '@images/avatar_director.jpg';
import avatarAndreyMalahov from '@images/avatar_andrey_malahov.jpg';
import avatarAniLorak from '@images/avatar_ani_lorak.jpg';
import avatarDenisKostyakov from '@images/avatar_denis_kostyakov.jpg';
import avatarUriyPostrigay from '@images/avatar_uriy_postrigay.jpg';
import avatarLeisanUtyasheva from '@images/avatar_leisan_utyasheva.jpg';
import avatarKonstantinMalasaev from '@images/avatar_konstantin_malasaev.jpg';
import avatarMihailBashtakov from '@images/avatar_mihail_bashtakov.jpg';
import avatarAlexandrNevskyi from '@images/avatar_alexandr_nevskyi.jpg';
import avatarAnastasiaSpiridonova from '@images/avatar_anastasia_spiridonova.jpg';

import bigAvatarMityaFomin from '@images/avatar_mitya_fomin@2x.jpg';
import bigAvatarValeriaLanskaya from '@images/avatar_valeria_lanskaya@2x.jpg';
import bigAvatarAnatoliyRudenko from '@images/avatar_anatoliy_rudenko@2x.jpg';
import bigAvatarPavelOsipov from '@images/avatar_pavel_osipov@2x.jpg';
import bigAvatarTwixiTwins from '@images/avatar_twixi_twins@2x.jpg';
import bigAvatarDirector from '@images/avatar_director@2x.jpg';
import bigAvatarAndreyMalahov from '@images/avatar_andrey_malahov@2x.jpg';
import bigAvatarAniLorak from '@images/avatar_ani_lorak@2x.jpg';
import bigAvatarDenisKostyakov from '@images/avatar_denis_kostyakov@2x.jpg';
import bigAvatarUriyPostrigay from '@images/avatar_uriy_postrigay@2x.jpg';
import bigAvatarLeisanUtyasheva from '@images/avatar_leisan_utyasheva@2x.jpg';
import bigAvatarKonstantinMalasaev from '@images/avatar_konstantin_malasaev@2x.jpg';
import bigAvatarMihailBashtakov from '@images/avatar_mihail_bashtakov@2x.jpg';
import bigAvatarAlexandrNevskyi from '@images/avatar_alexandr_nevskyi@2x.jpg';
import bigAvatarAnastasiaSpiridonova from '@images/avatar_anastasia_spiridonova@2x.jpg';

export const peopleList = [
  {
    avatar: avatarAniLorak,
    bigAvatar: bigAvatarAniLorak,
    title: 'Ани Лорак',
    text: 'Певица, композитор',
    subTitle:
      'О новых чертах характера близких, четверти без троек и ошеломительных блинчиках',
    quotes: [
      'Мы остались наедине со своими родными и близкими и по-другому открыли черты их характеров.',
      'Моя дочь закончила без троек четверть на домашнем обучении.',
      'Я отлично жарю блинчики, я — номер один по сырникам и неплохо, даже очень неплохо, делаю салаты.',
    ],
    about:
      'В 2020 году популярная украинская певица, композитор и автор текстов Ани Лорак выпустила live-альбом DIVA, покорила фанатов яркими синглами «Я бы летала», «Обещаю» и «Твоей любимой», получила премию Муз-ТВ и активно поддерживала молодых исполнителей.',
    videoId: '1224354',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarAndreyMalahov,
    bigAvatar: bigAvatarAndreyMalahov,
    title: 'Андрей Малахов',
    text: 'Телеведущий, шоумен, продюсер',
    subTitle:
      'О семейной Масленице, концерте в Большом театре и новом парке в Краснодаре',
    quotes: [
      'Что касается самых ярких воспоминаний 2020 года, наверное, это наша традиционная семейная вечеринка «Масленица». Это получилось последнее предкоронавирусное мероприятие. Мы пригласили всех наших близких друзей и знакомых. До пандемии казалось, что это нас всех не коснется.',
      'Уже в новых реалиях, это концерт в Большом театре, который я вел — «Мы вместе». В поддержку врачей, которые отдавали свои жизни, силы, время для борьбы с COVID-19.',
      'Новый парк рядом с футбольным стадионом в Краснодаре произвел на меня какой-то ошеломляющий эффект. Это одно из самых ярких архитектурных впечатлений 2020 года.',
    ],
    about:
      'Андрей Малахов — российский тележурналист, шоумен, продюсер, актер. С 2017 года ведущий программ «Андрей Малахов. Прямой эфир» и «Привет, Андрей!» на телеканале «Россия-1». До 2017 года на протяжении 25 лет работал на «Первом канале».',
    videoId: '1224350',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarMityaFomin,
    bigAvatar: bigAvatarMityaFomin,
    title: 'Митя Фомин',
    text: 'Певец, танцор, продюсер',
    subTitle: 'О новом альбоме, заработанных деньгах и квартире в Крыму',
    quotes: [
      'Самое позитивное воспоминание за 2020 год — это то, что я жив.',
      'В этом году мы дали очень много онлайн-концертов, в том числе благотворительных. В частности, на платформе Mail.ru, где заработали много денег для тех, кто в них действительно нуждается.',
      'В этом году я много отдыхал на Черном море, увидел много новых мест, познакомился с новыми людьми и, собственно, даже успел купить маленькую квартиру в Крыму, ремонтом которой сейчас и занимаюсь.',
    ],
    about:
      'Певец Митя Фомин ворвался в российский шоу-бизнес как фронтмен группы «Hi-Fi». Сейчас певец, танцор, продюсер и телеведущий работает над сольными проектами. В 2020 году он выпустил два студийных альбома — «Апрель» и «Слышь, да ладно».',
    videoId: '1224347',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarLeisanUtyasheva,
    bigAvatar: bigAvatarLeisanUtyasheva,
    title: 'Ляйсан Утяшева',
    text: 'Чемпионка Европы по художественной гимнастике, телеведущая',
    subTitle:
      'О позитивных эмоциях, новой зарядке и веселом времени с близкими',
    quotes: [
      'Этот год для всего шарика был очень тяжелым, и это понятно. Но те, кто переживал этот год в любви, все-таки плодил в себе позитивные эмоции, цеплялся за какие-то росточки позитива в этом мраке, мне кажется, что все-таки они выдержали.',
      'В этом году я наконец-то запустила зарядку, которую все от меня просили. Это была больше социальная история: мы с Пашей показали, как дома муж с женой могут делать классные зарядки, созваниваться с людьми и все-таки поддерживать этот фан.',
    ],
    about:
      'Ляйсан Утяшева — знаменитая российская спортсменка, заслуженный мастер спорта по художественной гимнастике, неоднократная победительница российских и международных соревнований. После ухода из большого спорта реализовала себя как ведущая, писатель, актриса и постановщик танцевальных шоу. В настоящее время ведет программу «Танцы» на телеканале ТНТ.',
    videoId: '1224358',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarPavelOsipov,
    bigAvatar: bigAvatarPavelOsipov,
    title: 'Паша Осипов',
    text:
      'Блогер, участник самого большого дома блогеров в России «Grand\u00A0House»',
    subTitle:
      'О двух миллионах подписчиков, новых возможностях и трудоголизме для всех',
    quotes: [
      'Про 2020-й год? Для меня он выдался и суперсложным, и суперменяющим мою жизнь.',
      'Себе я бы пожелал не расслабляться, в первую очередь. Потому что бывает, что я не очень и поработал, но такой сажусь вечерком: «Попью чаёчек, посмотрю фильм...» Нет, так не работает! Хочу еще больше работать, быть еще более продуктивным, еще более усердным. Себе я пожелаю вот это. Вам я пожелаю того же.',
    ],
    about:
      'Паша Осипов — блогер, фокусник, участник самого большого дома блогеров в России Grand House.',
    videoId: '1224336',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarDenisKostyakov,
    bigAvatar: bigAvatarDenisKostyakov,
    title: 'Денис Косяков',
    text: 'Актер театра и кино, сценарист, продюсер',
    subTitle:
      'О классных сериалах, новых шоу и бесценном времени, проведенном с семьей',
    quotes: [
      'Я мог бы долго рассказывать о том, что в 2020 году из-за того, что не было съемок и корпоративов, пришлось сидеть дома и написать несколько классных сериалов, придумать несколько интересных форматов шоу — и оно так и есть. Но все это кажется такой мелочью и меркнет на фоне того, что впервые в этом году я по-настоящему много времени провел с семьей.',
      'Как же было круто провести время с тремя этими пупсиками, один из которых — жена. Я поражаюсь, почему из-за самоизоляции в этом году распалось так много семей. По-моему, это было идеальное время, чтобы сблизиться с семьей.',
    ],
    about:
      'Денис Косяков — актер театра и кино, юморист, сценарист, продюсер и телеведущий. Победитель первого сезона шоу «Смех без правил». Он прославился своими ролями в комедийных сериалах «Зайцев+1» и «Остров».',
    videoId: '1224356',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarAlexandrNevskyi,
    bigAvatar: bigAvatarAlexandrNevskyi,
    title: 'Александр Невский',
    text: 'Российский культурист, киноактер, режиссер, сценарист и продюсер',
    subTitle: 'О насыщенном и рабочем 2020-м годе и оптимизме',
    quotes: [
      '2020 год заканчивается. Странный, тяжелый для всех нас и для меня. И тем не менее, лично я закончил две новые картины, одну новую книгу, написал массу статей по здоровому образу жизни, кинобизнесу. Выступал в СМИ по обе стороны океана, пропагандируя оптимизм.',
      'Всем вам в 2021-м я желаю счастья, здоровья. А также радуйте своих близких, радуйте себя и двигайтесь вперед!',
    ],
    about:
      'Александр Невский — российский культурист, киноактер, режиссер, сценарист и продюсер, также известный как «русский Арнольд Шварценеггер». Зрителям Александр запомнился своими ролями в картинах «Убийство в Вегасе», «Черная роза»',
    videoId: '1224367',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarValeriaLanskaya,
    bigAvatar: bigAvatarValeriaLanskaya,
    title: 'Валерия Ланская',
    text: 'Певица, актриса театра и кино',
    subTitle:
      'О родственниках, тоске по зрителям и долгожданной роли Анны Карениной',
    quotes: [
      'Самое прекрасное, что было в этом году — это то, что мы долго во время самоизоляции были вместе со своими семьями. Я была счастлива, что я так долго, каждый день, видела своего сына, мужа, маму, сестру.',
      'Самым ожидаемым для меня в этом году был, конечно же, выход на сцену Театра оперетты в роли Анны Карениной. Я очень ждала встречи со зрителями хоть в каком виде! Через одного, в шахматном порядке... Как угодно, лишь бы испытать вновь это чувство, когда ты выходишь на сцену и слышишь зал, слышишь дыхание зрителей и их аплодисменты. Это самое большое счастье для меня как для актрисы.',
    ],
    about:
      'Актриса и певица Валерия Ланская полюбилась россиянам ролями в теленовелле «Принцесса цирка», фильмах «Есенин», «Тариф „Новогодний“», «Рябиновый вальс», «Тёмный мир: Равновесие», многочисленных мюзиклах и опереттах. Валерия принимала участие в телевизионных проектах «Ледниковый период-2» и «Ледниковый период — лучшее» и была соведущей в 3-м сезоне телепроекта «Голос. Дети».',
    videoId: '1224343',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarMihailBashtakov,
    bigAvatar: bigAvatarMihailBashtakov,
    title: 'Михаил Башкатов',
    text: 'Актер, телеведущий',
    subTitle: 'О новых спектаклях, кулинарных талантах и о счастье',
    quotes: [
      '2020-й не был богат на проекты, но, тем не менее, я рад, что нам удалось выпустить спектакль «Все о мужчинах». Премьера совсем скоро. В начале года мы выпустили спектакль «ЖиЧ» с Егором Дружининым, я снялся в нескольких проектах, и это прекрасно, но это все о работе.',
      'Я благодарен этому году за то, что научился готовить с десяток блюд, среди которых один суп, как минимум. Я чудесно провел время с семьей на карантине. Я думаю, что тут я не оригинален.',
      'И вообще, спасибо 2020 году за то, что мы научились ценить какие-то простые вещи. Поняли, что для счастья нам нужно не так уж много. Достаточно чувствовать себя здоровым, достаточно встретиться с друзьями и прогуляться на свежем воздухе.',
    ],
    about:
      'Михаил Башкатов — российский актер и телеведущий. Стал известен как капитан команды Высшей лиги КВН «МаксимуМ» и участник комедийного шоу «Даешь молодежь!». Свою более серьезную актерскую карьеру он начал с небольшой роли в популярном сериале «Папины дочки», после чего его пригласили на работу в сериал «Кухня». После этого он также снялся в романтической комедии «С 8 марта, мужчины!» и в криминальной драме «Переводчик».',
    videoId: '1224360',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarAnatoliyRudenko,
    bigAvatar: bigAvatarAnatoliyRudenko,
    title: 'Анатолий Руденко',
    text: 'Актер',
    subTitle: 'О новом члене семьи, премьерах и спортивной форме',
    quotes: [
      'Поддерживаем спортивную форму — во МХАТе имени Горького есть все возможности для этого.',
      'У нас появился новый член семьи — собака Шерри, чему мы очень рады. Так что все хорошо, работа идет.',
    ],
    about:
      'Анатолий Руденко дебютировал в 13 лет в фильме Эльдара Рязанова «Привет, дуралеи!», а сейчас — один из самых востребованных актеров в театре и кино. В 2020 году в России вышло сразу 7 фильмов с его участием: «Расколотые сны», «И расцвёл подсолнух» и другие.',
    videoId: '1224348',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarDirector,
    bigAvatar: bigAvatarDirector,
    title: 'Директор Всего',
    text: 'Бизнесмен, бизнес-тренер, бизнес-музыкант',
    subTitle: 'О лучшем годе в своей жизни и о защите фрилансеров',
    quotes: [
      'Почему-то многие считают этот год сложным, а я так не считаю. Потому что с самого начала я сказал себе — этот год будет лучшим! И так и произошло. Этот год стал лучшим.',
      'Благодаря моей акции «Нет фрилансу» тысячи фрилансеров вернулись в офисы и свернули с пути нестабильности в путь к успеху.',
    ],
    about:
      'Директор Всего — «бизнесмен, бизнес-тренер, бизнес-музыкант». Альтер-эго музыканта Андрея Ли.',
    videoId: '1224344',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarTwixiTwins,
    bigAvatar: bigAvatarTwixiTwins,
    title: 'Близняшки TWIXI',
    text:
      'Блогеры, участницы самого большого дома блогеров в России «Grand\u00A0House»',
    subTitle: 'О переезде в Москву, успехе в TikTok и о своем пути',
    quotes: [
      'Мы совсем недавно переехали в Москву с одним «твиксом», а сейчас у нас в TikTok уже 4 миллиона.',
      'Самым ярким воспоминанием в 2020 году было не воспоминание, а некий путь, благодаря которому мы нашли себя. Мы обрели огромную аудиторию «твиксов» и очень этому рады.',
    ],
    about:
      'Близняшки TWIXI (TWIXI-Лера и TWIXI-Геля) — популярные TikTok блогеры, участницы самого большого дома блогеров в России Grand House.',
    videoId: '1224338',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarAnastasiaSpiridonova,
    bigAvatar: bigAvatarAnastasiaSpiridonova,
    title: 'Анастасия Спиридонова',
    text: 'Певица, музыкант, автор песен',
    subTitle: 'О путешествиях по России, пустой Москве и долгожданном концерте',
    quotes: [
      'Несмотря на то, что 2020 год для всех был крайне непростым, для меня в нем было очень много хороших моментов. Появилось больше времени, чтобы проводить его с семьей, вспомнить давно забытые кулинарные рецепты и смахнуть пыль с беговой дорожки.',
      'Во время самоизоляции, имея рабочий пропуск, мне удалось снять видео на новую песню «Я знаю мы расстанемся, и пусть» и запечатлеть уникальный момент пустой Москвы днем, когда нет ни машин, ни людей. Думаю, что это какой-то особенный клип для меня.',
      'После того, как нам было разрешено выйти на улицу, появилась возможность путешествовать по России. Я побывала в Псковской, Тверской, Ленинградской областях, и сбылась моя мечта — я побывала в Карелии, и считаю это место одним из красивейших в нашей стране.',
      'В сентябре у меня прошел сольный концерт и после долгого затишья получилось выйти к зрителям, спеть песни и получить овации, увидеть глаза, цветы, улыбки. Это был очень яркий момент в этом году.',
    ],
    about:
      'Анастасия Спиридонова — певица, автор песен и музыкант. Широкой публике Анастасия стала известна после своего участия в российском шоу «Голос», где она попала в число финалистов.',
    videoId: '1224366',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarKonstantinMalasaev,
    bigAvatar: bigAvatarKonstantinMalasaev,
    title: 'Константин Маласаев',
    text: 'Актер, шоумен, стендап-комик',
    subTitle:
      'О Занзибаре, когда он еще не стал мейнстримом, саморазвитии и семье',
    quotes: [
      'Начался 2020 год великолепно — мы съездили с женой в Турцию, потом съездили отдохнуть на Занзибар. И так получилось, что в 2020 году мы посетили именно те две страны, в которые стало можно ехать после весенней эпидемии.',
      'Появилось время для саморазвития. Я начал осваивать разные направления, которые всегда меня интересовали, но до которых никак не доходили руки. Это и монтаж, и таргетинг, и стендап.',
      'Самый главный плюс 2020 года — появилось очень много времени, чтобы провести его с семьей.',
    ],
    about:
      'Константин Маласаев — актер, шоумен, стендап-комик, член команды КВН «МаксимуМ», участник группы «USB» в телешоу Comedy Club.',
    videoId: '1224359',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
  {
    avatar: avatarUriyPostrigay,
    bigAvatar: bigAvatarUriyPostrigay,
    title: 'Юрий Постригай',
    text: 'Олимпийский чемпион по гребле на байдарках',
    subTitle:
      'Об активной работе, новых проектах и счастливом времени с семьей',
    quotes: [
      'Для меня уходящий год, несмотря на всю его сложность, был очень продуктивным и насыщенным. Я провел много мастер-классов, различных лекций, принимал участие в съемках для топовых изданий и телеканалов.',
      'На карантине я начал активно развивать свой блог, поменял кардинально рацион питания. Начал работу над созданием авторского гребного тренажера. Поучаствовал в открытии музея олимпийской славы в городе Пересвет, где теперь хранится моя олимпийская золотая медаль.',
      'Но самое главное — этот сложный год дал мне возможность очень много времени проводить вместе с моей семьей.',
    ],
    about:
      'Юрий Постригай — олимпийский чемпион по гребле на байдарках, чемпион Европы и мира, 17-кратный чемпион России.',
    videoId: '1242210',
    ogImageWidth: 1200,
    ogImageHeight: 627,
  },
];

export const defaultMetaTitle = '2020: вспомнить все хорошее';
export const defaultMetaDescription =
  '2020 год дался всему миру очень нелегко: произошло немало неприятных событий, многое пошло не по плану — но даже в такой ситуации можно найти что-то хорошее и светлое.';

export const title = 'Вспомнить все хорошее';
export const subTitle =
  '2020 год дался всему миру очень нелегко: произошло немало неприятных событий, многое пошло не по плану — но даже в такой ситуации можно найти что-то хорошее и светлое. Новости Mail.ru представляют спецпроект «Вспомнить все хорошее». В нем российские знаменитости рассказали о том, как они провели этот год, который по понятным причинам выдался очень нестандартным. При этом мы попросили героев вспоминать только самые хорошие, радостные, позитивные моменты, потому что негатива в этом году и так было предостаточно. Вот что из этого получилось.';
